<template>
<w-sliding-popup ref="slidingPopup" title="SQL문 보기" width="500px" @close="onClose">
  <div slot="content">
    <div class="title-h4 title-bar">SQL 문</div>
    <el-input type="textarea" readonly :autosize="{ minRows: 6 }" v-model="sqlText" placeholder="SQL문이 없습니다." />
  </div>
</w-sliding-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import { mapGetters } from 'vuex';
import msgUtil from '@/utils/message';

export default {
  name: 'WDbsessionSqlQueryShowPopup',
  data() {
    return {
      sqlText: '',
    };
  },
  computed: mapGetters(['selectedNode']),
  methods: {
    /**
     * 팝업을 열 때 SQL문을 설정한다.
     * row / sqlText 중 하나를 보내면 되며, sqlText가 있을 경우 해당 값을 바로 바인딩해준다.
     * @author Ju
     * @param  {[type]} row     세션 정보
     * @param  {[type]} sqlText SQL문
     */
    open(row, sqlText) {
      if (isNil(sqlText)) {
        this.setSQL(row);
      } else {
        this.sqlText = sqlText;
      }
      this.$refs.slidingPopup.open();
    },
    /**
     * 팝업을 닫을 때 SQL문을 초기화한다.
     * @author Ju
     * @return {[type]} [description]
     */
    onClose() {
      this.sqlText = '';
    },
    /**
     * DB 타입에 맞게 SQL문을 설정한다.
     * @author Ju
     * @param  {[type]} row [description]
     */
    setSQL(row) {
      const obj = this.selectedNode.obj;
      const objtypeId = obj.objtypeId;
      if (objtypeId === 'MYSQL') {
        this.sqlText = row.INFO;
      } else if (objtypeId === 'DB2') {
        this.sqlText = row.STMT_TEXT;
      } else if (objtypeId === 'POSTGRESQL') {
        this.sqlText = row.QUERY;
      } else {
        // ondemand 요청으로 SQL문을 조회한다.
        const queryId = this.getQueryIdOfDbType(objtypeId, obj.objProductId);
        const parameterMap = this.getParameterMapOfDbType(objtypeId, row);

        const params = {
          objId: obj.objId,
          queryId,
          parameterMap,
        };
        databaseTableInfoAPI
          .getCurrentDbsessionList(params)
          .then((result) => {
            if (result.data.success === true) {
              this.sqlText = isEmpty(result.data.data) ? null : result.data.data[0].SQL_TEXT;
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'SQL문', false));
            }
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'SQL문', false));
          });
      }
    },
    /**
     * DB 타입에 맞는 쿼리 아이디를 반환한다.
     * @author Ju
     * @param  {[type]} objtypeId    [description]
     * @param  {[type]} objProductId [description]
     * @return {[type]}              [description]
     */
    getQueryIdOfDbType(objtypeId, objProductId) {
      let queryId;
      switch (objtypeId) {
        case 'ORACLE':
          if (objProductId === '9i') {
            queryId = 'DBORSessionSQL_OR9i';
          } else {
            queryId = 'DBORSessionSQL';
          }
          break;
        case 'INFORMIX':
          queryId = 'DBINSessionSQL';
          break;
        case 'MSSQL':
          queryId = 'DBMSSessionSQL';
          break;
        case 'SYBASE':
          queryId = 'DBSYSessionSQL';
          break;
        case 'MYSQL':
          queryId = 'DBMYSessionSQL';
          break;
        case 'TIBERO':
          queryId = 'DBTBSessionSQL';
          break;
        case 'SYBASEIQ':
          queryId = 'DBIQSessionSQL';
          break;
        case 'ALTIBASE':
          queryId = 'DBATSessionSQL';
          break;
        case 'DB2':
          queryId = 'DBDB2SessionSQL';
          break;
        default:
          break;
      }
      return queryId;
    },
    /**
     * DB 타입에 맞는 파라미터맵을 반환한다.
     * @author Ju
     * @param  {[type]} objtypeId [description]
     * @param  {[type]} row       [description]
     * @return {[type]}           [description]
     */
    getParameterMapOfDbType(objtypeId, row) {
      const sid = this.getSidOfDbType(objtypeId, row);
      const parameterMap = {
        sid,
      };
      if (objtypeId === 'SYBASE') {
        parameterMap.sid2 = sid;
      } else if (objtypeId === 'TIBERO') {
        parameterMap.sqlid = row.SQL_ID;
      }
      return parameterMap;
    },
    /**
     * DB 타입에 맞는 SID를 반환한다.
     * @author Ju
     * @param  {[type]} objtypeId [description]
     * @param  {[type]} row       [description]
     * @return {[type]}           [description]
     */
    getSidOfDbType(objtypeId, row) {
      let sid;
      switch (objtypeId) {
        case 'MYSQL':
          sid = row.ID;
          break;
        case 'MSSQL':
          sid = row.SID;
          break;
        case 'TIBERO':
          sid = row.SID;
          break;
        case 'ALTIBASE':
          sid = row.CURRENT_STMT_ID;
          break;
        case 'SYBASE':
          sid = row.SPID;
          break;
        case 'DB2':
          sid = row.AGENT_ID;
          break;
        case 'POSTGRESQL':
          sid = row.PID;
          break;
        case 'ORACLE':
          sid = row.SID;
          break;
        // case 'INFORMIX':
        // case 'SYBASEIQ':
        default:
          break;
      }
      return sid;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/popup/DbsessionSqlQueryShowPopup.vue